import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Bank } from '../../entities/control-tables/bank';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class BankRequest extends BaseRequest {
  bank : Bank;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.bank = new Bank();
  }
}